// Times "typing bursts" so the staff dashboard can estimate each officer's
// typing speed. Numbers only: a burst is how many characters were typed and
// over how many milliseconds, never what was typed.
//
// A burst is a run of keystrokes with no pause longer than GAP_MS. The clock
// runs from the first keystroke to the last, so thinking time between bursts
// is not counted. Short bursts are dropped here (the server filters again).

export const GAP_MS = 2000;
export const MIN_BURST_CHARS = 10;
export const MIN_BURST_MS = 5000;

export interface TypingBurst {
  chars: number;
  ms: number;
}

export class BurstTracker {
  private start = 0;
  private last = 0;
  private chars = 0;

  constructor(private onBurst: (b: TypingBurst) => void, private gapMs = GAP_MS) {}

  /** Call for every character the officer types by hand. */
  input(count: number, now: number): void {
    if (count <= 0) return;
    if (this.chars > 0 && now - this.last > this.gapMs) this.finish();
    if (this.chars === 0) {
      this.start = now;
      this.chars = count;
    } else {
      this.chars += count;
    }
    this.last = now;
  }

  /** Close the burst in progress (a pause, blur, or page hide). */
  finish(): void {
    const ms = this.last - this.start;
    // chars - 1: the span begins at the first keystroke.
    const typed = this.chars - 1;
    if (typed >= MIN_BURST_CHARS && ms >= MIN_BURST_MS) this.onBurst({ chars: typed, ms });
    this.chars = 0;
  }
}
